import { Button, Stack } from "@mui/material";
import useAuditStore from "./useAuditStore";


export default function SwitchButton(){

    const {showResults, toggleResults} = useAuditStore()

    return (
        <Stack direction='row' justifyContent='center'>

            <Button 
                variant='outlined' 
                sx={{m: 2}} 
                onClick={toggleResults}
            >
                {showResults ? 'Voir la grille' : 'Voir les résultats'}
            </Button>

        </Stack>
    );
}